module.exports = __webpack_public_path__ + "/7e2444666c97509e9dcafda5d3399123.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/folder_icon.svg
 ** module id = 1238
 ** module chunks = 0
 **/